import { render } from "./RenovarPlano.vue?vue&type=template&id=2e5cb8f8&scoped=true&ts=true"
import script from "./RenovarPlano.vue?vue&type=script&lang=ts"
export * from "./RenovarPlano.vue?vue&type=script&lang=ts"

import "./RenovarPlano.vue?vue&type=style&index=0&id=2e5cb8f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5cb8f8"]])

export default __exports__